import { render } from "./StandardConstructor.vue?vue&type=template&id=1f7f2e3b"
import script from "./StandardConstructor.vue?vue&type=script&lang=js"
export * from "./StandardConstructor.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__